<template>
  <div class="commoditysearch" style="position: relative">
    <div v-if="!isShow" :class="{'mask': !isShow}">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <div class="search-container">
      <div
        class="search-input-wrapper"
        :style="{
          border: `2px solid ${datas.borderColor || '#e0e0e0'}`,
          backgroundColor: datas.backgroundColor || '#f5f5f5',
          borderColor: datas.borderColor || '#e0e0e0',
          borderRadius: `${datas.moduleStyleType  ==1 ? 30 :10}px`,
        }"
      >
        <div style="display: flex; width: 100%">
          <i
            :style="{ color: datas.borderColor || '#333' }"
            class="iconfont icon-sousuo"
            style="margin-right: 10px"
          ></i>
          <div
            style="width: 100%;display: flex;align-items: center;"
            :style="{
              fontFamily: datas.fontFamily,
              fontSize: `${datas.fontSize}px`,
              textAlign:
                datas.textPosition === 0
                  ? 'left'
                  : datas.textPosition === 1
                  ? 'center'
                  : 'right',
            }"
          >
            <span
              :style="{
                color: datas.textColor,
                fontSize: `${datas.fontSize}px`,
              }"
              >{{ datas.text }}</span
            >
          </div>
        </div>
        <van-button
          style="width: 80px; background-color: var(--theme-primary)"
          type="info"
          size="small"
          :style="{
            borderRadius:  `${datas.moduleStyleType  ==1 ? 30 :10}px`,
          }"
        >
          <span
            style="padding: 0 10px"
            :style="{
              fontSize: `${datas.fontSize}px`,
            }"
          >
            搜索
          </span>
        </van-button>
      </div>
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
export default {
  name: "commoditysearch",
  props: {
    datas: {
      type: Object,
      default: () => ({
        backgroundColor: "",
        borderColor: "",
        borderRadius: 30,
        heights: 28,
        hotords: [],
        id: "",
        placeholder: "请输入关键词",
        position: "left",
        sweep: false,
        text: "商品搜索",
        textColor: "",
        textPosition: 0,
      }),
    },
    isShow: Boolean,
  },
  methods: {
    handleSearch() {
      // 搜索逻辑可以在这里实现
      console.log("搜索功能触发");
    },
  },
};
</script>

<style scoped lang="scss">
.commoditysearch {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.search-input-wrapper {
  padding: 1px 1px 1px 10px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.search-icon {
  color: #999;
  font-size: 16px;
  margin-right: 8px;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  height: 100%;
}

.search-input::placeholder {
  color: #999;
  font-size: 14px;
}

.search-button {
  // padding: 0 15px;
  background-color: #1989fa;
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.search-button:hover {
  background-color: #1677ff;
}

.search-button:active {
  background-color: #0f57b3;
}
</style>
